import React from 'react'
import styles from '../helper/Title.module.css'

const Title = ({title,subTitle}) => {
  return (
    <div className={styles.title}>
    <h2>
    {title} <span>{subTitle}</span>
    </h2>
    </div>

  )
}

export default Title